export const useListingNavigation = (
  callback: (event: PopStateEvent) => void,
) => {
  onMounted(() => {
    window.addEventListener('popstate', callback);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', callback);
  });
};
